import api from "./axiosInstance";

export const getClearanceProducts = async ({
  halaman,
  jumlah,
  keyword,
  token
}) => {
  const res = await api.get(
    `https://hoopsdevteam.com/api_web/controler/rudrunner/clearance.php`,
    {
      params: {
        index: 1,
        halaman,
        jumlah,
        keyword,
      },
      headers: {
        Authorization: token,
      },
    }
  );

  return res.data;
};